import type { Animation, CustomAnimationValue } from "@/types";

export const FPS = 30;

// Resolve sentinel keyframe values (currently only randomRotation) to numbers.
// Shared between the non-instanced AnimationClip pipeline and the instanced sampler.
const convertValues = (
  values: Array<number | CustomAnimationValue>,
): number[] =>
  values.map((value) =>
    value === "randomRotation"
      ? Math.random() * Math.PI * 2
      : (value as number),
  );

export type ExtractedKeyframes = {
  fps: number;
  times: number[];
  values: number[];
};

// Flatten a manifest Animation's frame-based keys into the (times[], values[])
// shape three.js KeyframeTracks and Interpolants expect.
export const extractAnimationKeyframes = (
  animation: Animation,
): ExtractedKeyframes => {
  const fps = animation.framePerSecond || FPS;
  const times = animation.keys.map((key) => key.frame / fps);
  const values = animation.keys.flatMap((key) => convertValues(key.values));

  return { fps, times, values };
};
